<template>
    <div class="content">
        <div class="container-fluid">
            <PageTitle :title="$t('CurrencyList.currencyList')">
                <template v-slot:left>
                    <i class="fa fa-euro-sign fa-3x text-billing"/>
                </template>
            </PageTitle>
            <transition mode="out-in" name="fade">
                <APILoading v-if="currencies === undefined || currencies === null" key="loading" :color="$data.$colors.billing" :text="$t('CurrencyList.loadingCurrencies')"/>
                <div v-else key="currencies" class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <v-client-table :data="currencies" :columns="table.columns" :options="table.options">
                                    <span slot="name" slot-scope="props" v-html="props.row.name" class="font-bold"/>
                                </v-client-table>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageTitle from "../../../shared/misc/PageTitle";
import APILoading from "../../../shared/API/APILoading";
import { permissiveFilter } from "../../../../helpers/VueTable";

export default {
    name: "CurrencyList",
    components: { APILoading, PageTitle },
    data() {
        return {
            table: {
                columns: ["name", "alpha3ISO", "symbol", "localSymbol", "euroRate", "decimalDigits"],
                options: {
                    sortable: ["name", "alpha3ISO", "symbol", "localSymbol", "euroRate", "decimalDigits"],
                    perPage: 10,
                    headings: {
                        name: this.$t("CurrencyList.name"),
                        alpha3ISO: this.$t("CurrencyList.alpha3ISO"),
                        symbol: this.$t("CurrencyList.symbol"),
                        localSymbol: this.$t("CurrencyList.localSymbol"),
                        euroRate: this.$t("CurrencyList.euroRate"),
                        decimalDigits: this.$t("CurrencyList.decimalDigits"),
                    },
                    orderBy: {
                        column: "name",
                    },
                    filterAlgorithm: {
                        name: (row, query) => permissiveFilter(row.name, query),
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters("currencies", {
            currencies: "currencies",
        }),
    },
    async created() {
        await this.checkUserAuthentication();
    },
    methods: {
        ...mapActions("user", {
            checkUserAuthentication: "checkUserAuthentication",
        }),
    },
};
</script>

<style scoped>

</style>